export default __webpack_public_path__ + "static/xeno-process-03-fb6616b154870afbafb84e871c6d0c75.png";